export default "__VITE_ASSET__BjWU$e5o__"